// Port of api/fuel/app/classes/insights/size/sampled.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

export default Segment.extend({
	name: 'sampled',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['sampled'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var sampled = []
		var gameTrack = [ {}, {}, {}, {} ]
		var names = ['0 plays', '1 play', '2 plays', '3+ plays']

		for (var i = 0; i <= 3; i++) {
			sampled.push({
				name: names[i],
				games: 0,
				playavg: 0,
				own: 0,
				ratingavg: 0,
				ratings: 0
			})
		}

		var candidates = Util.queryFast(
			'SELECT l.game_id AS g, l.log_date AS d, COALESCE(c.collection_own, 0) AS o,' +
			' COALESCE(c.collection_plays, 0) AS pt, COALESCE(c.collection_rating, 0) AS r,' +
			' COALESCE(SUM(p.play_count), 0) AS pb' +
			' FROM (log_user_collection l LEFT JOIN collection c ON c.game_id = l.game_id AND c.user_id = l.user_id)' +
			' LEFT JOIN play p ON p.game_id = l.game_id AND p.user_id = l.user_id AND p.play_date <= l.log_date - 86400, game g' +
			' WHERE l.log_context = ' + Constants.LOG_CONTEXT_ADDED +
			(exclude ? ' AND g.game_type = 1' : '') +
			' AND l.game_id = g.game_id AND l.user_id = ' + owner.get_id() +
			' GROUP BY l.game_id ORDER BY g.game_sortname ASC'
		)

		for (var c = 0; c < candidates.length; c++) {
			var candidate = candidates[c]
			var index = (parseInt(candidate.pb, 10) || 0) > 2 ? 3 : (parseInt(candidate.pb, 10) || 0)
			gameTrack[index][parseInt(candidate.g, 10)] = parseInt(candidate.d, 10) || 0
			sampled[index].games++
			sampled[index].ratingavg += parseFloat(candidate.r) || 0
			if (parseFloat(candidate.r) || 0) sampled[index].ratings++
			if (parseInt(candidate.o, 10)) sampled[index].own++
			sampled[index].playavg += (parseInt(candidate.pt, 10) || 0) - (parseInt(candidate.pb, 10) || 0)
		}

		for (var s = 0; s <= 3; s++) {
			if (sampled[s].games > 1) sampled[s].playavg = Math.round((sampled[s].playavg / sampled[s].games) * 10) / 10
			if (sampled[s].ratings > 1) sampled[s].ratingavg = Math.round((sampled[s].ratingavg / sampled[s].ratings) * 10) / 10
			if (sampled[s].own) sampled[s].own = Math.round((100 / sampled[s].games) * sampled[s].own)
		}

		if (detail) {
			var games = []
			var detailIndex = parseInt(vars.index, 10) || 0
			var ids = Object.keys(gameTrack[detailIndex])
			for (var g = 0; g < ids.length; g++) {
				var gameId = parseInt(ids[g], 10)
				this._references.games.push(gameId)
				games.push({
					id: gameId,
					added: gameTrack[detailIndex][ids[g]]
				})
			}
			return { games: games }
		}

		return {
			sampled: sampled
		}
	}
})
